import {ADD_ID_PROSPECTO} from "./actions";

const initialState = {
};

const prospectReducer = (state = initialState, action) => {
    const {
        type,
        idProspecto
    } = action;
  
    switch (type) {
        case ADD_ID_PROSPECTO:
            return {
                idProspecto
            };

        default:{
            return state;
        }
    }
};

export default prospectReducer;
